import { render, staticRenderFns } from "./BaseOutlineSecondaryButton.vue?vue&type=template&id=2394efa2&scoped=true&"
import script from "./BaseOutlineSecondaryButton.vue?vue&type=script&lang=js&"
export * from "./BaseOutlineSecondaryButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseOutlineSecondaryButton.vue?vue&type=style&index=0&id=2394efa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2394efa2",
  null
  
)

export default component.exports